import apiClient from './client';
import { apiError } from './errors';
import type { ApiResponse } from '../types';

/** Rename the current user's organization. Returns the updated name. Admin/SA only (enforced server-side). */
export async function updateOrganization(data: { name: string }): Promise<string> {
  try {
    const response = await apiClient.patch<ApiResponse<{ organization_name: string }>>(
      '/api/v1/organization',
      data
    );
    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.message || 'Failed to update organization');
    }
    return response.data.data.organization_name;
  } catch (err) {
    throw apiError(err, 'Failed to update organization');
  }
}
